if (!customElements.get("variant-picker")) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
    }

    get selectedOptionValues() {
      const options = this.querySelectorAll('.m-product-option select, .m-product-option input');
      const selectedValues = new Map();

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (field.tagName.toLowerCase() === "select") {
          const selectedOption = Array.from(field.options).find(
            (opt) => opt.selected && !opt.disabled
          );
          if (selectedOption) {
            selectedValues.set(fieldName, selectedOption.dataset.optionValueId);
          }
        } else if (
          field.tagName.toLowerCase() === "input" &&
          field.type === "radio"
        ) {
          const checkedInput = field.checked ? field : null;
          if (checkedInput) {
            selectedValues.set(fieldName, checkedInput.dataset.optionValueId);
          }
        }
      });

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (!selectedValues.has(fieldName)) {
          if (field.tagName.toLowerCase() === "select") {
            const firstValidOption = Array.from(field.options).find(
              (opt) => !opt.disabled
            );
            if (firstValidOption) {
              selectedValues.set(
                fieldName,
                firstValidOption.dataset.optionValueId
              );
            }
          } else if (
            field.tagName.toLowerCase() === "input" &&
            field.type === "radio"
          ) {
            const firstInput = field;
            if (firstInput) {
              selectedValues.set(fieldName, firstInput.dataset.optionValueId);
            }
          }
        }
      });

      const result = [];
      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;
        if (selectedValues.has(fieldName)) {
          const optionValueId = selectedValues.get(fieldName);
          if (optionValueId && !result.includes(optionValueId)) {
            result.push(optionValueId);
          }
        }
      });
      return result;
    }

    connectedCallback() {
      this.addEventListener('change', (event) => {
        const target = this.getInputForEventTarget(event.target);
        MinimogEvents.emit(MinimogTheme.pubSubEvents.optionValueSelectionChange, { data: { selectedOptionValues: this.selectedOptionValues, event, target } });
      });
    }

    getInputForEventTarget(target) {
      return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
    }
  }
  customElements.define("variant-picker", VariantPicker);
}

(() => {
  const styleId = 'iyb-bundle-plus-layout';
  const existingStyle = document.getElementById(styleId);
  if (existingStyle) existingStyle.remove();

  const style = document.createElement('style');
  style.id = styleId;
  style.textContent = `
    variant-picker[data-iyb-bundle-product="true"] .iyb-bundle-products {
      display: grid !important;
      align-items: center !important;
      justify-items: center !important;
      width: 100% !important;
      height: 88px !important;
      min-height: 88px !important;
      margin: 8px 0 6px !important;
      padding: 0 5px !important;
      overflow: visible !important;
      gap: 0 !important;
    }

    variant-picker[data-iyb-bundle-product="true"] .iyb-bundle-products--1 {
      grid-template-columns: 1fr !important;
    }

    variant-picker[data-iyb-bundle-product="true"] .iyb-bundle-products--2 {
      grid-template-columns: minmax(0, 1fr) 16px minmax(0, 1fr) !important;
    }

    variant-picker[data-iyb-bundle-product="true"] .iyb-bundle-products--3 {
      grid-template-columns: minmax(0, 1fr) 12px minmax(0, 1fr) 12px minmax(0, 1fr) !important;
    }

    variant-picker[data-iyb-bundle-product="true"] .iyb-bundle-product-image {
      display: block !important;
      margin: 0 !important;
      max-width: none !important;
      object-fit: contain !important;
      object-position: center !important;
      transform: none !important;
      transform-origin: center !important;
    }

    variant-picker[data-iyb-bundle-product="true"] .iyb-bundle-products--1 .iyb-bundle-product-image {
      width: 58px !important;
      height: 80px !important;
      grid-column: 1 !important;
      grid-row: 1 !important;
    }

    variant-picker[data-iyb-bundle-product="true"] .iyb-bundle-products--2 .iyb-bundle-product-image {
      width: 46px !important;
      height: 76px !important;
    }

    variant-picker[data-iyb-bundle-product="true"] .iyb-bundle-products--3 .iyb-bundle-product-image {
      width: 31px !important;
      height: 68px !important;
    }

    variant-picker[data-iyb-bundle-product="true"] .iyb-bundle-products--2 .iyb-bundle-product-image:nth-of-type(1) {
      grid-column: 1 !important;
      grid-row: 1 !important;
    }

    variant-picker[data-iyb-bundle-product="true"] .iyb-bundle-products--2 .iyb-bundle-product-image:nth-of-type(2) {
      grid-column: 3 !important;
      grid-row: 1 !important;
    }

    variant-picker[data-iyb-bundle-product="true"] .iyb-bundle-products--3 .iyb-bundle-product-image:nth-of-type(1) {
      grid-column: 1 !important;
      grid-row: 1 !important;
    }

    variant-picker[data-iyb-bundle-product="true"] .iyb-bundle-products--3 .iyb-bundle-product-image:nth-of-type(2) {
      grid-column: 3 !important;
      grid-row: 1 !important;
    }

    variant-picker[data-iyb-bundle-product="true"] .iyb-bundle-products--3 .iyb-bundle-product-image:nth-of-type(3) {
      grid-column: 5 !important;
      grid-row: 1 !important;
    }

    variant-picker[data-iyb-bundle-product="true"] .iyb-bundle-products--2::after,
    variant-picker[data-iyb-bundle-product="true"] .iyb-bundle-products--3::before,
    variant-picker[data-iyb-bundle-product="true"] .iyb-bundle-products--3::after {
      color: #672235 !important;
      font-weight: 900 !important;
      line-height: 1 !important;
      align-self: center !important;
      justify-self: center !important;
      transform: none !important;
      position: static !important;
      z-index: 2 !important;
    }

    variant-picker[data-iyb-bundle-product="true"] .iyb-bundle-products--2::after {
      content: '+' !important;
      grid-column: 2 !important;
      grid-row: 1 !important;
      font-size: 17px !important;
    }

    variant-picker[data-iyb-bundle-product="true"] .iyb-bundle-products--3::before {
      content: '+' !important;
      grid-column: 2 !important;
      grid-row: 1 !important;
      font-size: 14px !important;
    }

    variant-picker[data-iyb-bundle-product="true"] .iyb-bundle-products--3::after {
      content: '+' !important;
      grid-column: 4 !important;
      grid-row: 1 !important;
      font-size: 14px !important;
    }

    @media (max-width: 749px) {
      variant-picker[data-iyb-bundle-product="true"] .iyb-bundle-products {
        height: 84px !important;
        min-height: 84px !important;
        margin: 8px 0 5px !important;
        padding: 0 3px !important;
      }

      variant-picker[data-iyb-bundle-product="true"] .iyb-bundle-products--1 .iyb-bundle-product-image {
        width: 54px !important;
        height: 76px !important;
      }

      variant-picker[data-iyb-bundle-product="true"] .iyb-bundle-products--2 {
        grid-template-columns: minmax(0, 1fr) 14px minmax(0, 1fr) !important;
      }

      variant-picker[data-iyb-bundle-product="true"] .iyb-bundle-products--3 {
        grid-template-columns: minmax(0, 1fr) 10px minmax(0, 1fr) 10px minmax(0, 1fr) !important;
      }

      variant-picker[data-iyb-bundle-product="true"] .iyb-bundle-products--2 .iyb-bundle-product-image {
        width: 43px !important;
        height: 72px !important;
      }

      variant-picker[data-iyb-bundle-product="true"] .iyb-bundle-products--3 .iyb-bundle-product-image {
        width: 29px !important;
        height: 64px !important;
      }

      variant-picker[data-iyb-bundle-product="true"] .iyb-bundle-products--2::after {
        font-size: 15px !important;
      }

      variant-picker[data-iyb-bundle-product="true"] .iyb-bundle-products--3::before,
      variant-picker[data-iyb-bundle-product="true"] .iyb-bundle-products--3::after {
        font-size: 12px !important;
      }
    }
  `;

  document.head.appendChild(style);
})();
